module.exports = __webpack_public_path__ + "static/media/inclusive-play.214c8e5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inclusive-play.svg
// module id = ./src/assets/images/inclusive-play.svg
// module chunks = 0